import Navbar from "@/components/landing/Navbar";
import DiagnosticHero from "@/components/diagnostic/DiagnosticHero";
import DiagnosticTest from "@/components/diagnostic/DiagnosticTest";
import Glossary from "@/components/diagnostic/Glossary";
import MethodIntro from "@/components/landing/MethodIntro";
import Challenge from "@/components/landing/Challenge";
import Solution from "@/components/landing/Solution";
import AboutUs from "@/components/landing/AboutUs";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import PowerQuote from "@/components/landing/PowerQuote";
import ClosingCTA from "@/components/landing/ClosingCTA";
import CalendlySection from "@/components/landing/CalendlySection";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      {/* Hero: Promesa del diagnóstico */}
      <DiagnosticHero />
      {/* Test interactivo de 10 preguntas */}
      <DiagnosticTest />
      {/* Glosario de términos */}
      <Glossary />
      {/* Introducción al método */}
      <MethodIntro />
      {/* 1) Puntos de dolor (El Desafío) */}
      <Challenge />
      {/* 2) Arquitectura / Solución */}
      <Solution />
      {/* 3) Quiénes somos */}
      <AboutUs />
      {/* 4) Los arquitectos - Trayectoria global */}
      <Stats />
      {/* 5) Testimonios */}
      <Testimonials />
      {/* 6) El valor de tu trayectoria */}
      <PowerQuote />
      {/* 7) CTA para agendar */}
      <ClosingCTA />
      {/* 8) Calendly */}
      <CalendlySection />
      {/* 9) Footer */}
      <Footer />
      <WhatsAppButton />
    </main>
  );
};

export default Index;
